import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import {
  getLiveVideosRequest,
  livevideoReportRequest,
} from "../../../modules/admin-modules/liveVideos/Actions";

const LiveVideosReport = ({ setSelectedData }) => {
  const dispatch = useDispatch();
  const { video_id } = useParams();
  const [videoId, setVideoId] = useState(video_id || "");

  useEffect(() => {
    dispatch(getLiveVideosRequest());
  }, []);

  useEffect(() => {
    if (video_id) setVideoId(video_id);
  }, [video_id]);

  useEffect(() => {
    if (videoId) dispatch(livevideoReportRequest(videoId));
  }, [videoId]);

  const liveVideos = useSelector((state) => state.adminLiveVideos.liveVideos);
  const liveVideosReport = useSelector(
    (state) => state.adminLiveVideos.liveVideosReport
  );
  const iaLoading = useSelector((state) => state.adminLiveVideos.iaLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  const liveVideosOptions = liveVideos?.map((data) => {
    return { value: data.id, label: data.title };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };

  const Data = liveVideosReport?.students
    ? liveVideosReport?.students?.map((data, index) => {
        return {
          ...data,
          index: `#${index + 1}`,
          id: data?.id,
          name: data?.name,
          group_name: data?.group?.name,
          phone: data?.phone,
        };
      })
    : [];
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    // {
    //   Header: " المجموعة",
    //   accessor: "group_name",
    // },
    {
      Header: " هاتف  الطالب",
      accessor: "phone",
    },
  ];
  const headers = [
    { label: "name", key: "name" },
    { label: "group_name", key: "group_name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_phoe" },
  ];
  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير الفيديوهات المباشرة
          </Text>
          <Flex w="40%" justifyContent="space-between" alignItems="center">
            <Select
              options={liveVideosOptions}
              isMulti={false}
              onChange={(data) => {
                setVideoId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select Live Video"
              value={
                liveVideosOptions?.find((opt) => opt.value == videoId) || null
              }
            />
            {Data?.length != 0 && (
              <Box
                mx="10px"
                border="1px solid gray"
                borderRadius="8px"
                padding="10px"
              >
                <CSVLink
                  headers={headers}
                  data={Data?.length != 0 ? Data : []}
                  filename={"paid-report.csv"}
                  className="btn btn-primary"
                  target="_blank"
                >
                  Download
                </CSVLink>
              </Box>
            )}
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data || []}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={iaLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default LiveVideosReport;
